import { httpRequest } from "@services/http";
import { JourneyPath } from "@models/journeyPath.model";

/** Every live pricing group on the contract, across its sheets. The one-group-
 *  per-population rule is contract-wide (MPN-1592), so the group picker needs
 *  the whole contract, not just the sheet being edited (MPN-1713). */
export class CommandListContractJourneyPaths {
  async run(contractId: number): Promise<JourneyPath[]> {
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/finance/contracts/${contractId}/journey-paths/`;
    const response = await httpRequest<any[]>(url, { method: "GET", cache: "no-store" });
    return response.map((row) => new JourneyPath(row));
  }
}
